import {createFileRoute} from '@tanstack/react-router';

import DiagnosticReport from '@/patient/views/DiagnosticReport';

export const Route = createFileRoute('/(patient)/diagnostic-reports/$diagnosticReportId')({
  component: DiagnosticReport,
  loader: function ({params}) {
    if (!params.diagnosticReportId) {
      throw new Error('diagnosticReportId param is required');
    }
    return {
      diagnosticReportId: params.diagnosticReportId
    };
  }
});
